// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__34stI","col":"styles_col__34DtG","fulfillmentStatus":"styles_fulfillmentStatus__CeeMu","emailCol":"styles_emailCol__266IS"};